var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "leo-flex leo-flex-col leo-justify-between",
      class: _vm.isShow
        ? "leo-banner--active leo-opacity-100 leo-visible leo-mt-2xl tablet:leo-mt-0"
        : "leo-invisible leo-opacity-0 leo-absolute",
      style: { top: `${_vm.positionTop}px` },
    },
    [
      _c("div", { staticClass: "leo-row tablet:leo-gap-md" }, [
        _c(
          "div",
          {
            staticClass:
              "leo-col-8 leo-px-xl desktop:leo-offset-2 tablet:leo-px-3xl",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "leo-text-left leo-rounded-xs leo-z-8 leo-py-lg leo-px-xl leo-flex leo-items-center leo-border-sm leo-border-solid",
                class: {
                  [`leo-border-${_vm.borderColor}`]: _vm.borderColor,
                  [`leo-bg-${_vm.backgroundColor}`]: _vm.backgroundColor,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "leo-mb-auto leo-mr-md" },
                  [
                    _c("leo-icon", {
                      attrs: {
                        type: `${_vm.icon}`,
                        color: `${_vm.iconColor}`,
                        size: "lg",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "leo-banner--content leo-block leo-break-word tablet:leo-break-normal",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "leo-text-sm leo-text-secondary" },
                      [_vm._v(" " + _vm._s(_vm.readMessage) + " ")]
                    ),
                  ]
                ),
                _vm.closeButton
                  ? _c(
                      "div",
                      {
                        staticClass: "leo-mb-auto leo-ml-md",
                        on: { click: _vm.handleClose },
                      },
                      [
                        _c("leo-icon", {
                          staticClass: "leo-cursor-pointer",
                          attrs: {
                            type: "close",
                            color: "secondary",
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }